const homepage = {
    title: 'Home',
    homeTitle: "We're a small technology & software consulting company.",
    homeSubtitle:
        'We focus on designing smart, functional, and simple solutions tailored to our customers.',
}

export default homepage
